"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var empty_1 = __importDefault(require("./empty"));
var loading_1 = require("../loading");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    showColumns: true,
    showSeparator: true,
};
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Table.prototype.renderHeaders = function () {
        var _a = this.props, columns = _a.columns, showColumns = _a.showColumns;
        if (showColumns) {
            var label_1;
            return columns.map(function (header, index) {
                label_1 = header.label ? header.label : header.key;
                return (React.createElement("div", { className: styles.header, key: index }, label_1));
            });
        }
        return null;
    };
    Table.prototype.generateGridStyles = function () {
        var columns = this.props.columns;
        var gridTemplateColumns = columns.reduce(function (previousValue, currentValue) {
            if (currentValue.width) {
                previousValue.push(currentValue.width);
            }
            else {
                previousValue.push("minmax(0, 1fr)");
            }
            return previousValue;
        }, []);
        var columnStyles = { gridTemplateColumns: gridTemplateColumns.join(" ") };
        return columnStyles;
    };
    Table.prototype.renderDefaultEmptyView = function () {
        var defaultEmptyLabel = this.props.defaultEmptyLabel;
        if (!defaultEmptyLabel) {
            defaultEmptyLabel = "There is no available data...";
        }
        return (React.createElement(empty_1.default, { span: this.props.columns.length, title: "No data", message: defaultEmptyLabel }));
    };
    Table.prototype.renderDefaultLoadingView = function () {
        var defaultLoadingLabel = this.props.defaultLoadingLabel;
        if (!defaultLoadingLabel) {
            defaultLoadingLabel = "Retrieving your data...";
        }
        return (React.createElement(empty_1.default, { span: this.props.columns.length, title: null, message: React.createElement(loading_1.Loading, { style: "inverted", label: defaultLoadingLabel }) }));
    };
    Table.prototype.renderRows = function () {
        var _a;
        var _b = this.props, data = _b.data, columns = _b.columns, cellClassName = _b.cellClassName, loading = _b.loading, showSeparator = _b.showSeparator;
        var _c = this.props, emptyView = _c.emptyView, loadingView = _c.loadingView;
        if (loading) {
            if (!loadingView) {
                loadingView = this.renderDefaultLoadingView();
            }
            return loadingView;
        }
        if (!data || (data && !data.length)) {
            if (!emptyView) {
                emptyView = this.renderDefaultEmptyView();
            }
            return emptyView;
        }
        var className = cx((_a = {
                cell: true
            },
            _a[cellClassName] = cellClassName,
            _a.separator = showSeparator,
            _a));
        var rows = data.map(function (row, index) {
            return columns.map(function (column, cellIndex) {
                return (React.createElement("div", { className: className, key: "".concat(index, "_").concat(cellIndex) }, column.renderer ? column.renderer(row) : row[column.key]));
            });
        });
        return rows;
    };
    Table.prototype.render = function () {
        var _a;
        var columnStyles = this.generateGridStyles();
        var className = this.props.className;
        var className_ = cx((_a = {
                outer: true
            },
            _a[className] = className,
            _a));
        return (React.createElement("div", { className: className_, style: columnStyles },
            this.renderHeaders(),
            this.renderRows()));
    };
    Table.defaultProps = defaultProps;
    return Table;
}(React.Component));
exports.Table = Table;
exports.default = Table;
//# sourceMappingURL=table.js.map